import { getRequest, postRequest } from '@utils/apiUtils';

export const getGradingLimitsList = () => {
  return getRequest<CapBayApiData<GradingLimits.GradingLimitsList[]>>('/p2p-admin/grading-limits/list');
};

export const getAllThemes = () => {
  return getRequest<CapBayApiData<Inputs.SelectOption[]>>('/p2p-admin/grading-limits/themes');
};

export const postUpdateGradingLimit = (payload: GradingLimits.UpdateGradingLimitPayload) => {
  return postRequest<CapBayApiData>('/p2p-admin/grading-limits/update', payload);
};

export const postDeactivateGradingLimit = (payload: GradingLimits.GradingLimitActivePayload) => {
  return postRequest<CapBayApiData>('/p2p-admin/grading-limits/deactivate', payload);
};

export const postActivateGradingLimit = (payload: GradingLimits.GradingLimitActivePayload) => {
  return postRequest<CapBayApiData>('/p2p-admin/grading-limits/activate', payload);
};

export const postCreateGradingLimit = (payload: GradingLimits.CreateGradingLimitPayload) => {
  return postRequest<CapBayApiData>('/p2p-admin/grading-limits/create', payload);
};
